import { jsxs as m, jsx as a } from "react/jsx-runtime";
import { useState as D } from "react";
import v from "classnames";
import _ from "../../../../icons/FavouritesIcon.js";
import { getGridItemIcon as j } from "../utils.js";
import { s as t } from "../../../../explorer-grid-item.module-DeIZLQ5d.js";
const b = ({
  item: e,
  parent: l,
  editing: u,
  actions: h,
  isSelected: N,
  isActive: C,
  isUpdated: k,
  isMenuOpen: x,
  isInGroup: s,
  contextMenu: r,
  onToggleMenu: n
}) => {
  const [I, c] = D(!1), { onClickItem: d, onDoubleClickItem: f } = h, { onFavouritesToggle: p } = u ?? {};
  let i = null;
  const g = (o) => {
    i && clearTimeout(i), o.detail === 1 ? (o.preventDefault(), i = setTimeout(() => {
      d && d(e, l, s);
    }, 200)) : o.detail === 2 && f && f(e, l, s);
  }, y = j(e, I);
  return /* @__PURE__ */ m(
    "div",
    {
      id: `file_explorer_template_${e.id}`,
      className: v(
        t.root,
        N && t.selected,
        e.type === "template" ? "file-explorer-template" : "file-explorer-folder",
        C && t.active,
        k && t.updated,
        x && t.menuOpen,
        !!r && t.withOptions
      ),
      children: [
        /* @__PURE__ */ m(
          "div",
          {
            className: t.container,
            onClick: g,
            onMouseEnter: () => c(!0),
            onMouseLeave: () => c(!1),
            onContextMenu: (o) => {
              n && (o.preventDefault(), n(e.id));
            },
            "data-testid": `template_${e.id}`,
            children: [
              /* @__PURE__ */ a("div", { className: t.iconContainer, children: /* @__PURE__ */ a(
                "img",
                {
                  className: t.icon,
                  src: y,
                  alt: ""
                }
              ) }),
              /* @__PURE__ */ a("div", { className: t.nameContainer, children: /* @__PURE__ */ a("div", { className: t.name, children: e.name.replaceAll(/<[^>]*>/g, "") }) }),
              /* @__PURE__ */ a(
                _,
                {
                  className: v(t.fave, e.favorite && t.checked),
                  onClick: (o) => {
                    o.preventDefault(), o.stopPropagation(), p && (e.external || p({ id: e.id, type: e.type, checked: !e.favorite }));
                  }
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ a("div", { className: t.optionsButton, children: r(e, l) })
      ]
    }
  );
};
export {
  b as default
};
